import { Flex, Group, Text } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./smart-link.module.css"

type Props = {
  /** Leading icon (already colored by the caller) */
  icon: ReactNode
  /** Primary text label */
  label: ReactNode
  /** Right-side accent (count, status, chevron) */
  trailing?: ReactNode
  /** Override the right-side text color (defaults to brand primary) */
  trailingColor?: string
  /** Click handler turns the row into a clickable link */
  onClick?: () => void
}

/**
 * Compact link-like row: `[icon] label …………… trailing`.
 * Used in detail sidebars to surface related artifacts (invoices,
 * delivery notes, kanban entries) with an at-a-glance count or status.
 */
export function SmartLink({ icon, label, trailing, trailingColor, onClick }: Props) {
  return (
    <Flex
      className={classes.root}
      align="center"
      justify="space-between"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Group gap={8}>
        {icon}
        <Text fz={14} c="var(--mantine-color-dark-7)">
          {label}
        </Text>
      </Group>
      {trailing != null && (
        <Text fz={14} fw={600} c={trailingColor ?? "var(--mantine-color-brand-6)"}>
          {trailing}
        </Text>
      )}
    </Flex>
  )
}
